import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../api/axiosConfig';

const Register: React.FC = () => {
  const { t } = useTranslation();

  const [contact, setContact] = useState(''); // email hoặc phone
  const [showSuccess, setShowSuccess] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setError('');
    setShowSuccess(false);
    setLoading(true);

    // Regex kiểm tra email & phone
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^(?:\+?84|0)[1-9][0-9]{7,14}$/; // 0xxxx hoặc +84xxxx

    let payload: any = {
      source: 'Đăng ký nhận tin',
    };

    if (emailRegex.test(contact)) {
      payload.email = contact;
    } else if (phoneRegex.test(contact)) {
      payload.phone = contact;
    } else {
      setError(t('register.errors.invalid_contact') || 'Vui lòng nhập Email hoặc Số điện thoại hợp lệ.');
      setLoading(false);
      return;
    }

    try {
      await api.post('/contacts', payload);
      setShowSuccess(true);
      setContact('');
    } catch (err: any) {
      console.error('❌ Lỗi đăng ký nhận tin:', err);
      setError(
        err.response?.data?.message ||
          t('register.errors.network') ||
          'Đăng ký thất bại, vui lòng thử lại.'
      );
    } finally {
      setLoading(false);
      setTimeout(() => {
        setShowSuccess(false);
        setError('');
      }, 4000);
    }
  };

  return (
    <div
      className="w-full bg-cover bg-center flex items-end px-6 py-16 min-h-[300px] md:min-h-[400px]"
      style={{ backgroundImage: `url(/images/background/Register.png)` }}
    >
      <div className="bg-white p-6 w-full max-w-md shadow-lg relative overflow-hidden">
        <h3 className="text-sm font-bold text-gray-900 mb-2">{t('register.title')}</h3>
        <p className="text-sm text-gray-600 mb-6 leading-relaxed">
          {t('register.subtitle')}
        </p>

        <form className="flex gap-2 flex-col sm:flex-row" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder={t('register.placeholder') || 'Nhập Email hoặc Số điện thoại'}
            value={contact}
            onChange={(e) => setContact(e.target.value)}
            required
            className={`flex-grow px-4 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 ${
              error ? 'border-red-500 focus:ring-red-400' : 'border-gray-300 focus:ring-green-500'
            }`}
          />
          <button
            type="submit"
            disabled={loading}
            className="px-5 py-2 bg-green-700 hover:bg-green-800 text-white text-sm font-semibold rounded-md transition disabled:bg-green-400"
          >
            {loading ? t('register.loading') || 'Đang gửi...' : t('register.submit_button')}
          </button>
        </form>

        {error && (
          <p className="mt-3 text-sm text-red-600 bg-red-50 p-2 rounded-md">{error}</p>
        )}

        {showSuccess && (
          <div className="absolute inset-0 bg-white bg-opacity-95 flex flex-col items-center justify-center p-6 text-center animate-fadeIn">
            <img src="/images/CTG-logo/Logo1.png" alt="Logo" className="w-16 h-16 mb-4" />
            <h4 className="text-lg font-semibold text-green-700 mb-2">
              {t('register.success.title') || 'Đăng ký thành công!'}
            </h4>
            <p className="text-sm text-gray-700">
              {t('register.success.message') ||
                'Cảm ơn bạn đã đăng ký nhận thông tin mới nhất từ chúng tôi.'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Register;
